module.exports = require('./head');



//////////////////
// WEBPACK FOOTER
// ../~/lodash/first.js
// module id = 1137
// module chunks = 0